import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment-timezone';

const defaultFrom = moment()
    .tz('America/Toronto')
    .subtract(30, 'days')
    .format('YYYY-MM-DD');
const defaultTo = moment().tz('America/Toronto').format('YYYY-MM-DD');

const emptyTotals = {
    shiftAmount: 0,
    staffyPayFee: 0,
    platformFee: 0,
    platformFeeTax: 0,
    netPaid: 0,
};

const initialState = {
    isLoading: false,
    error: null,
    rows: [],
    count: 0,
    totals: { ...emptyTotals },
    from: null,
    to: null,
    filters: {
        from: defaultFrom,
        to: defaultTo,
        stafferId: null,
        stafferName: '',
    },
};

const slice = createSlice({
    name: 'paidContractorInvoiceReport',
    initialState,
    reducers: {
        fetchReport: state => {
            state.isLoading = true;
            state.error = null;
        },
        reportFetched: (state, { payload }) => {
            state.isLoading = false;
            state.rows = payload.rows || [];
            state.count = payload.count || 0;
            state.totals = payload.totals || { ...emptyTotals };
            state.from = payload.from || null;
            state.to = payload.to || null;
        },
        reportFetchFailed: (state, { payload }) => {
            state.isLoading = false;
            state.error =
                payload || 'Failed to load paid contractor invoices report';
        },
        setFilters: (state, { payload }) => {
            state.filters = { ...state.filters, ...payload };
        },
        resetFilters: state => {
            state.filters = {
                from: defaultFrom,
                to: defaultTo,
                stafferId: null,
                stafferName: '',
            };
        },
    },
});

export const {
    fetchReport,
    reportFetched,
    reportFetchFailed,
    setFilters,
    resetFilters,
} = slice.actions;

export default slice.reducer;

export const selectPaidContractorInvoiceReport = state =>
    state.paidContractorInvoiceReport;
